import { render, staticRenderFns } from "./Permisos.vue?vue&type=template&id=2dd3e6fd&scoped=true&"
import script from "./Permisos.vue?vue&type=script&lang=js&"
export * from "./Permisos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd3e6fd",
  null
  
)

export default component.exports